/** Do not edit directly **/
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: none;
}

:host([opened]) {
  display: block;
}